<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="{{iconClass}}"></i>
        </div>
        <div class="title">
            <h3>{{heading}}</h3>
        </div>
        <!-- <div>
            <div id="google_translate_element"></div> 
        </div> -->
        <!-- <div class="icon notification-icon" (click)="goToNotificationList()">
            <i class="fas fa-bell"></i>
            <span *ngIf="notificationListLength > 0" class="notification-badge">{{notificationListLength}}</span>
        </div> -->
    </div>
</header>